import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryNav() {
  const featuredCategories = categories.filter((c) => c.featured);

  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-[1200px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading mb-3">
            资源分类导航
          </h2>
          <p className="text-foreground-500 text-sm max-w-[500px] mx-auto">
            涵盖设计、开发、AI、学习等多个领域，快速找到你需要的免费资源
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
          {featuredCategories.map((category) => (
            <Link
              key={category.id}
              to={`/category/${category.slug}`}
              className="group bg-background-50 border border-background-200/70 rounded-xl p-5 hover:border-primary-200 hover:bg-primary-50/20 transition-all duration-300"
            >
              <div className="w-10 h-10 rounded-lg bg-primary-50 flex items-center justify-center mb-3 group-hover:bg-primary-100 transition-colors">
                <i className={`${category.icon} text-lg text-primary-600`}></i>
              </div>
              <h3 className="text-foreground-900 font-semibold text-sm mb-1 font-heading">
                {category.name}
              </h3>
              <p className="text-foreground-400 text-xs leading-relaxed line-clamp-2 mb-2">
                {category.description}
              </p>
              <span className="text-primary-500 text-xs font-medium">
                {category.resourceCount} 个资源 →
              </span>
            </Link>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/categories"
            className="inline-flex items-center gap-2 px-6 py-2.5 bg-secondary-50 hover:bg-secondary-100 text-secondary-700 rounded-lg text-sm font-medium transition-colors"
          >
            查看全部 12 个分类
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}